import setBuilderFormState from './set-builder-form-state';

export default function handleCartFormChange(e) {
  // set active states on accordions
  const accordion = e.target.closest('.product-builder-accordion');
  if (accordion) {
    const accordionContent = accordion.querySelector('.product-builder-accordion-content');
    const accordionContents = document.querySelectorAll('.product-builder-accordion-content');
    accordionContents.forEach((a) => {
      a.classList.remove('accordion-show');
      a.classList.add('accordion-hide');
    });
    accordionContent.classList.add('accordion-show');
  }

  setBuilderFormState();
}
